export default "__VITE_ASSET__CSE_HV6Q__"